import React from 'react';
import InputField from '../../../../components/input-field/InputField';
import ToggleRow from '../../../../components/toggle-row/ToggleRow';
import SmallJSONEditor from '../../../../components/small-json-editor/SmallJSONEditor';
import ValidationService from '../../../../services/ValidationService';
import RESTService from '../../../../services/RESTService';
import Dropdown from '../../../../components/dropdown/Dropdown';
import RoutingService from '../../../../services/RoutingService';
import ComponentHelper from '../../../../supers/ComponentHelper';
import TestRunnerModal from '../../../../components/test-runner-modal/TestRunnerModal';
import CommonService from '../../../../services/CommonService';
import SampleRequestCard from '../../../../components/sample-request-card/SampleRequestCard';
import _ from 'lodash';
const VS = new ValidationService();
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();

class ExchangeConnector extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = this.defaultState();
		this.scanForParams();
		this.autoBind([
			'defaultState',
			'onBuildConnectionState',
			'onValueChange',
			'onTestConnection',
			'onChecked',
			'handleAuthenticationConfigChange',
			'handleAuthorizationConfigChange',
			'handleImpersonationConfigChange',
			'handleTraitsFeaturesChange',
			'onServerVersionChange',
			'onAuthenticationTypeChange',
			'onAuthorizationTypeChange',
			'onImpersonationTypeChange',
			'onClearConnection',
			'isValidConnection',
			'onBuildConnection',
			'onCreateConnection',
			'buildTypeDefault',
			'scanForParams',
			'onSetEmpty',
			'onClearValue',
			'onDefaultChange',
			'getIsDisabled'
		]);
	}

	componentDidMount() {
		connect.getAgents().then(res => {
			this.setData('agents', res.data);
		});
	}

	defaultState = () => {
		if (this.props.connection) {
			return this.onBuildConnectionState(this.props.connection);
		}

		return {
			testing: false,
			name: '',
			connectionDataOpen: false,
			authOpen: false,
			authorizationOpen: false,
			impersonationOpen: false,
			traitsOpen: false,
			sslCertValidation: true,
			debugLogEnabled: false,
			agents: [],
			agentContent: '',
			agentsOpen: false,
			testOperation: '',
			url: '',
			serverVersion: 'Not specified',
			authType: 'ntlm',
			authConfigContent: '',
			authorizationType: 'ExchangeCredentials',
			authorizationContent: '',
			impersonationType: 'SmtpAddress',
			impersoncationContent: '',
			traitsClass: '',
			traitsItemFeatures: '',
			runningTest: false,
			requestParams: {},
			disabled: {}
		};
	};

	onBuildConnectionState = conn => {
		let config = conn.configuration;
		let cc = config.connection || {};
		let state = {
			testing: conn.testing,
			name: conn.name,
			testOperation: '',
			connectionDataOpen: config.connection ? true : false,
			authOpen: config.authentication ? true : false,
			authorizationOpen: config.authorization ? true : false,
			impersonationOpen: config.impersonation ? true : false,
			traitsOpen: config.traits ? true : false,
			agents: this.data.agents ? this.data.agents : [],
			agentContent: conn.agent ? conn.agent : '',
			agentsOpen: conn.agent && conn.agent.length > 0 ? true : false,
			url: cc.url ? cc.url : '',
			serverVersion: cc.version ? cc.version : '',
			sslCertValidation: cc.strictssl ? cc.strictssl : true,
			debugLogEnabled: cc.debuglogenabled ? cc.debuglogenabled : false,
			authType: config.authentication ? config.authentication.type : 'ntlm',
			authConfigContent: config.authentication ? JSON.stringify(config.authentication.configuration, undefined, 2) : '',
			authorizationType: config.authorization ? config.authorization.type : 'ExchangeCredentials',
			authorizationContent: config.authorization ? JSON.stringify(config.authorization.configuration, undefined, 2) : '',
			impersonationType: config.impersonation ? config.impersonation.type : '',
			impersoncationContent: config.impersonation ? JSON.stringify(config.impersonation.configuration, undefined, 2) : '',
			traitsClass: config.traits ? config.traits.class : '',
			traitsItemFeatures: config.traits ? JSON.stringify(config.traits.features, undefined, 2) : '',
			runningTest: false,
			requestParams: {},
			disabled: {}
		};

		let disabled = {};
		if (state.testing || this.props.endpoint) {
			if (state.authorizationContent.length > 0) {
				disabled.authorizationContent = true;
			}
			if (state.url.length > 0) {
				disabled.url = true;
			}
			if (state.authConfigContent.length > 0) {
				disabled.authConfigContent = true;
			}
			if (state.impersoncationContent.length > 0) {
				disabled.impersoncationContent = true;
			}
			if (state.traitsClass.length > 0) {
				disabled.traitsClass = true;
			}
			if (state.traitsItemFeatures.length > 0) {
				disabled.traitsItemFeatures = true;
			}
			if (state.authorizationType.length > 0) {
				disabled.authorizationType = true;
			}
			if (state.serverVersion.length > 0) {
				disabled.serverVersion = true;
			}
			if (state.authType.length > 0) {
				disabled.authType = true;
			}
			if (state.impersonationType.length > 0) {
				disabled.impersonationType = true;
			}
			if (state.agentsOpen) {
				disabled.agent = true;
			}
		}
		state.disabled = disabled;
		return state;
	};

	getIsDisabled(field) {
		return this.data.disabled[field];
	}

	onBuildConnection = () => {
		this.invalidForm = false;
		let data = this.data;
		let connection = {
			name: data.name,
			type: 'ews-exchange-connector'
		};

		let config = (connection.configuration = {});

		if (data.testing) {
			connection.operation = data.testOperation;
		}

		if (data.connectionDataOpen) {
			let configConn = (config.connection = {
				debuglogenabled: data.debugLogEnabled,
				strictssl: data.sslCertValidation
			});

			if (data.url.length > 0) {
				configConn.url = data.url;
			}

			if (data.serverVersion.length > 0) {
				configConn.version = data.serverVersion;
			}
		}

		if (data.authOpen) {
			let auth = (config.authentication = {
				type: data.authType
			});

			if (data.authConfigContent.length > 0) {
				let val = CS.safelyParseJSON(data.authConfigContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				auth.configuration = val;
			}
		}

		if (data.authorizationOpen) {
			let authorize = (config.authorization = {
				type: data.authorizationType
			});

			if (data.authorizationContent) {
				let val = CS.safelyParseJSON(data.authorizationContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				authorize.configuration = val;
			}
		}

		if (data.impersonationOpen) {
			let impersonate = (config.impersonation = {
				type: data.impersonationType
			});

			if (data.impersoncationContent.length > 0) {
				let val = CS.safelyParseJSON(data.impersoncationContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				impersonate.configuration = val;
			}
		}

		if (data.traitsOpen) {
			let traits = (config.traits = {});
			if (data.traitsClass.length > 0) {
				traits.class = data.traitsClass;
			}

			if (data.traitsItemFeatures.length > 0) {
				let val = CS.safelyParseJSON(data.traitsItemFeatures);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				traits.features = val;
			}
		}

		if (data.agentsOpen) {
			connection.agent = data.agentContent;
		} else {
			connection.agent = '';
		}

		return connection;
	};

	onAgentChange = evt => {
		if (evt.value) {
			this.setData('agentContent', evt.value);
		}
	};

	getAgentOptions = () => {
		let agents = [];
		_.forEach(this.data.agents, ag => {
			agents.push({
				label: ag.name,
				value: ag.name
			});
		});
		return agents;
	};

	onValueChange = evt => {
		const { name, value } = evt.target;
		if (name === 'name' && !VS.validateName(value)) {
			return;
		}
		this.observe(() => {
			this.data[name] = value;
			this.scanForParams();
		});
	};

	isValidConnection = () => {
		let data = this.data;

		if (data.name.length === 0) {
			return true;
		}

		if (data.connectionDataOpen) {
			if (data.url.length === 0) {
				return true;
			}

			if (data.serverVersion === 'Not specified') {
				return true;
			}
		}

		if (data.traitsOpen) {
			if (data.traitsClass.length === 0) {
				return true;
			}

			if (data.traitsItemFeatures.length === 0) {
				return true;
			}
		}

		return false;
	};

	buildTestConnection = () => {
		let connection = this.onBuildConnection();
		if (this.invalidForm) {
			return false;
		}
		let config = {};
		let data = this.data;

		if (!data.disabled.authorizationContent && data.connectionDataOpen) {
			config.connection = connection.configuration.connection;
		}

		if (!data.disabled.authConfigContent && data.authOpen) {
			config.authentication = connection.configuration.authentication;
		}

		if (!data.disabled.authorizationContent && data.authorizationOpen) {
			config.authorization = connection.configuration.authorization;
		}

		if (!data.disabled.impersoncationContent && data.impersonationOpen) {
			config.impersonation = connection.configuration.impersonation;
		}

		if (!data.disabled.traitsItemFeatures && data.traitsOpen) {
			config.traits = connection.configuration.traits;
		}

		let testData = CS.buildRequestTestData(this.data.requestParams);
		testData._async = this.data.async ? true : false;
		return {
			application: 'global',
			sandbox: RS.getCurrentEnvironment(),
			endpoint: {
				action: this.data.testOperation,
				configuration: config,
				connection: connection.name,
				templates: CS.buildRequestTemplate(this.data.requestParams),
				type: 'operation'
			},
			testValues: testData
		};
	};

	onTestConnection = () => {
		return connect.testConnection(this.buildTestConnection());
	};

	onClearConnection = () => {
		this.observe(() => {
			this.data = this.defaultState();
		});
	};

	toggleAsync = () => {
		this.setData('async', !this.data.async);
	};

	onCreateConnection = () => {
		let connection = this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		if (this.props.connection) {
			delete connection.type;
			connect
				.updateConnection(connection)
				.then(res => {
					this.observe(() => {
						this.data = this.onBuildConnectionState(res.data);
					});
					RS.showSuccess();
				})
				.catch(err => {
					RS.smartError(err);
				});
		} else {
			connect
				.createConnection(connection)
				.then(() => {
					RS.showSuccess();
					RS.goToRoute('/connections');
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	};

	onChecked = evt => {
		const { dataset, checked } = evt.target;
		this.setData(dataset.name, checked);
	};

	onAuthenticationTypeChange = evt => {
		this.setData('authType', evt.value);
	};

	onAuthorizationTypeChange = evt => {
		this.setData('authorizationType', evt.value);
	};

	onServerVersionChange = evt => {
		this.setData('serverVersion', evt.value);
	};

	onImpersonationTypeChange = evt => {
		this.setData('impersonationType', evt.value);
	};

	handleAuthenticationConfigChange = newValue => {
		this.observe(() => {
			this.data.authConfigContent = newValue;
			this.scanForParams();
		});
	};

	handleAuthorizationConfigChange = newValue => {
		this.observe(() => {
			this.data.authorizationContent = newValue;
			this.scanForParams();
		});
	};

	handleImpersonationConfigChange = newValue => {
		this.observe(() => {
			this.data.impersoncationContent = newValue;
			this.scanForParams();
		});
	};

	handleTraitsFeaturesChange = newValue => {
		this.observe(() => {
			this.data.traitsItemFeatures = newValue;
			this.scanForParams();
		});
	};

	toggleTestRunner = () => {
		this.setData('runningTest', !this.data.runningTest);
	};

	runTest = () => {
		if (this.data.testOperation.length === 0) {
			return RS.showInfo('Please provide an operation');
		}
		this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		this.observe(() => {
			this.data.runningTest = true;
		});
	};

	scanForParams() {
		let keys = ['url', 'authConfigContent', 'authorizationContent', 'impersoncationContent', 'traitsItemFeatures', 'traitsClass'];
		this.data.requestParams = CS.buildRequestParams(keys, this.data);
		if (this.props.endpointWatcher) {
			this.props.endpointWatcher({
				cmp: this,
				data: this.data,
				builder: this.buildTestConnection
			});
		}
	}

	onActionChange = evt => {
		this.setData('testOperation', evt.target.value);
	};

	onSetEmpty(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = '';
			});
		}
	}

	onClearValue(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = undefined;
			});
		}
	}

	onDefaultChange(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				let field = this.data.requestParams[name];
				field.value = evt.target.value;
				this.data.requestParams[name] = field;
			});
		}
	}

	buildTypeDefault(details, param) {
		return (
			<div className="inline-btn-input hbox vcenter default">
				<input
					className="text-input"
					type="text"
					placeholder={details.value === '' ? 'Empty String' : 'None'}
					value={details.value}
					data-name={param}
					onChange={this.onDefaultChange}
				/>
				<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
					Set as empty
				</button>
				<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
					Clear
				</button>
			</div>
		);
	}

	render() {
		let {
			testing,
			testOperation,
			name,
			connectionDataOpen,
			authOpen,
			authorizationOpen,
			impersonationOpen,
			traitsOpen,
			agentsOpen,
			agentContent,
			url,
			serverVersion,
			sslCertValidation,
			debugLogEnabled,
			authType,
			authConfigContent,
			authorizationType,
			authorizationContent,
			impersonationType,
			impersoncationContent,
			traitsClass,
			traitsItemFeatures,
			runningTest,
			async
		} = this.data;
		return (
			<div className="exchangewebservice-connector-cmp">
				<div className="step-card shadow animated fadeIn">
					<div className="hbox">
						<InputField
							label="Name"
							subText="Use only lowercase characters, numbers or hyphens."
							type="text"
							name="name"
							value={name}
							handleChange={this.onValueChange}
							disabled={this.props.connection ? true : false}
							required
							autoFocus
						/>
					</div>
					<ToggleRow
						name="Connection Data"
						details={
							this.props.endpoint
								? 'Define server version, url and enable/disable ssl and logs.'
								: "This information is typically defined at connection level, but can be defined in the endpoint too. Note that if you define connection data at connection-level you won't be able to define any header at endpoint-level."
						}
						toggleOn={connectionDataOpen}
						keyName={'connectionDataOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						required={this.props.endpoint ? true : false}
						content={
							<div className={'connection-data-ctn'}>
								<InputField
									label="URL"
									type="text"
									name="url"
									subText="The UPN method must define the fully qualified domain name (FQDN) for the location of the user account."
									value={url}
									handleChange={this.onValueChange}
									required
									disabled={this.getIsDisabled('url')}
								/>
								<Dropdown
									className="toggle-select-dd"
									label="Server Version"
									value={serverVersion}
									handleChange={this.onServerVersionChange}
									disabled={this.getIsDisabled('serverVersion')}
									name="serverVersion"
									required={this.props.endpoint ? true : false}
									options={[
										{
											label: 'Not specified',
											value: 'Not specified'
										},
										{
											label: 'Exchange 2007 Service Pack 1',
											value: 'Exchange2007_SP1'
										},
										{
											label: 'Exchange 2010 (initial release)',
											value: 'Exchange2010'
										},
										{
											label: 'Exchange 2010 Service Pack 1',
											value: 'Exchange2010_SP1'
										},
										{
											label: 'Exchange 2010 Service Pack 2',
											value: 'Exchange2010_SP2'
										},
										{
											label: 'Exchange 2013 (initial release)',
											value: 'Exchange2013'
										},
										{
											label: 'Exchange 2013 Service Pack 1',
											value: 'Exchange2013_SP1'
										},
										{
											label: 'Exchange 2015',
											value: 'Exchange2015'
										},
										{
											label: 'Exchange 2016',
											value: 'Exchange2016'
										}
									]}
								/>
								<ToggleRow
									name="SSL Certificate Validation"
									details="The SSL validation can be disabled altogether in order to request servers using a certificate signed by an unknown Certificate Authority or a self-signed certificate. This is insecure and is recommended for testing purposes only."
									toggleOn={sslCertValidation}
									keyName={'sslCertValidation'}
									onToggle={this.onChecked}
									offContent={
										<div className="json-message">
											<i className="mdi mdi-alert" /> Insecure
										</div>
									}
								/>
								<ToggleRow
									className="debug-toggle"
									name="Debug Log Enabled"
									details="Enable exchange debugging features."
									toggleOn={debugLogEnabled}
									keyName={'debugLogEnabled'}
									onToggle={this.onChecked}
								/>
							</div>
						}
					/>
					<ToggleRow
						name="Authentication"
						details={
							this.props.endpoint
								? 'Configure in which way your connection is going to authenticate against the exchange server.'
								: "Note that if you define authentication config at connection-level you won't be able to define it at endpoint-level."
						}
						toggleOn={authOpen}
						keyName={'authOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="authenication-ctn">
								<Dropdown
									className="toggle-select-dd"
									label="Type"
									value={authType}
									handleChange={this.onAuthenticationTypeChange}
									name="authType"
									disabled={this.getIsDisabled('authType')}
									options={[
										{
											label: 'NTLM authentication protocol',
											value: 'ntlm'
										}
									]}
								/>
								<div className="authentication-configuration-content vbox vcenter">
									<div className="exchange-sub-title">Authentication Configuration</div>
									<SmallJSONEditor
										name="authConfigContent"
										value={authConfigContent}
										onChange={this.handleAuthenticationConfigChange}
										readOnly={this.getIsDisabled('authConfigContent')}
									/>
									<div className="json-message">Place here the configuration for the selected authentication protocol.</div>
								</div>
							</div>
						}
					/>
					<ToggleRow
						name="Authorization"
						details={
							this.props.endpoint
								? 'Configure authorization protocol to communicate with the exchange server.'
								: "Note that if you define authorization config at connection-level you won't be able to define it at endpoint-level."
						}
						toggleOn={authorizationOpen}
						keyName={'authorizationOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="authenication-ctn">
								<Dropdown
									className="toggle-select-dd"
									label="Type"
									value={authorizationType}
									handleChange={this.onAuthorizationTypeChange}
									name="authorizationType"
									disabled={this.getIsDisabled('authorizationType')}
									options={[
										{
											label: 'Exchange Credentials',
											value: 'ExchangeCredentials'
										}
									]}
								/>
								<div className="authentication-configuration-content vbox vcenter">
									<div className="exchange-sub-title">Authorization Configuration</div>
									<SmallJSONEditor
										name="authorizationContent"
										value={authorizationContent}
										onChange={this.handleAuthorizationConfigChange}
										readOnly={this.getIsDisabled('authorizationContent')}
									/>
									<div className="json-message">Place here the configuration for the selected authorization protocol.</div>
								</div>
							</div>
						}
					/>
					<ToggleRow
						name="Impersonation"
						details={
							this.props.endpoint
								? "Exchange Impersonation enables a caller to impersonate a given user account. This enables the caller to perform operations by using the permissions that are associated with the impersonated account, instead of the permissions that are associated with the caller's account."
								: "Note that if you define impersonation config at connection-level you won't be able to define it at endpoint-level."
						}
						toggleOn={impersonationOpen}
						keyName={'impersonationOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="authenication-ctn">
								<Dropdown
									className="toggle-select-dd"
									label="Type"
									value={impersonationType}
									handleChange={this.onImpersonationTypeChange}
									name="impersonationType"
									disabled={this.getIsDisabled('impersonationType')}
									subText={'The exchange impersonation protocol.'}
									options={[
										{
											label: 'Not specified',
											value: 'Not specified'
										},
										{
											label: 'User principal name (UPN)',
											value: 'PrincipalName'
										},
										{
											label: 'Security identifier (SID)',
											value: 'SID'
										},
										{
											label: 'Primary SMTP address',
											value: 'PrimarySmtpAddress'
										},
										{
											label: 'SMTP address',
											value: 'SmtpAddress'
										}
									]}
								/>
								<div className="authentication-configuration-content vbox vcenter">
									<div className="exchange-sub-title">Impersonation Configuration</div>
									<SmallJSONEditor
										name="authConfigContent"
										value={impersoncationContent}
										onChange={this.handleImpersonationConfigChange}
										readOnly={this.getIsDisabled('impersoncationContent')}
									/>
									<div className="json-message">Place here the configuration for the selected authentication protocol.</div>
								</div>
							</div>
						}
					/>
					<ToggleRow
						name="Traits"
						details={
							this.props.endpoint
								? 'Configure impersonation mechanism to comunicate with the exchange server.'
								: "Note that if you define traits config at connection-level you won't be able to define it at endpoint-level. As each Exchange operation (defined at endpoint-level) support different traits configuration you most likely want to leave this field disabled at connection-level'."
						}
						toggleOn={traitsOpen}
						keyName={'traitsOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						required={this.props.endpoint ? true : false}
						content={
							<div className="authenication-ctn">
								<div className="exchange-input-sub-title">Item Class</div>
								<InputField
									label="Exchange actions are applied to Items. You must specify which kind of Item you want to work with. (Eg. &quot;email&quot;, &quot;folder&quot;, etc.)."
									type="text"
									name="traitsClass"
									value={traitsClass}
									handleChange={this.onValueChange}
									disabled={this.getIsDisabled('traitsClass')}
									required
								/>
								<div className="authentication-configuration-content vbox vcenter">
									<div className="exchange-sub-title">Item Features {this.props.endpoint ? <span>*</span> : ''}</div>
									<SmallJSONEditor
										name="authConfigContent"
										value={traitsItemFeatures}
										readOnly={this.getIsDisabled('traitsItemFeatures')}
										onChange={this.handleTraitsFeaturesChange}
									/>
								</div>
							</div>
						}
					/>
					{!this.props.endpoint && (
						<ToggleRow
							name="Use an On-premise agent"
							details={
								'An agent is a process that runs in a virtual machine installed in a secure network. Once configured, it establishes a Web Socket connection with the Core Services platform, enabling the use of connectors that would otherwise be unreachable from the cloud.'
							}
							toggleOn={agentsOpen}
							keyName={'agentsOpen'}
							onToggle={this.onChecked}
							disabled={this.getIsDisabled('agent')}
							content={
								<div className="body-content vbox vcenter">
									<Dropdown
										className="w-100"
										label="Agent"
										value={agentContent}
										handleChange={this.onAgentChange}
										name="agentContent"
										disabled={this.getIsDisabled('agent')}
										options={this.getAgentOptions()}
									/>
								</div>
							}
						/>
					)}
					{testing &&
						!this.props.endpoint && (
							<div className="test-ctn vbox">
								<SampleRequestCard
									requestParams={this.data.requestParams}
									buildRequestFields={this.buildTypeDefault}
									validTest={true}
									onTest={this.runTest}
									async={async}
									toggleAsync={this.toggleAsync}
									content={
										<div className="hbox hright">
											<InputField
												label="Operation"
												subText="Operations enable you to access information from the Exchange store."
												type="text"
												name="testOperation"
												value={testOperation}
												handleChange={this.onActionChange}
												required
												autoFocus
											/>
										</div>
									}
								/>
								<TestRunnerModal isOpen={runningTest} onClose={this.toggleTestRunner} runTest={this.onTestConnection} async={async} />
							</div>
						)}
					<div className={`btn-ctn ${this.props.endpoint ? 'hidden' : ''}`}>
						<button className="btn m-r-20" onClick={this.onClearConnection}>
							{this.props.connection ? 'Undo Changes' : 'Clear'}
						</button>
						<button className="btn primary" onClick={this.onCreateConnection} disabled={this.isValidConnection()}>
							{this.props.connection ? 'Save Connection' : 'Create Connection'}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default ExchangeConnector;



// WEBPACK FOOTER //
// ./src/views/connections-panel/connection-creator/exchange-connector/ExchangeConnector.js